// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const msalConfig = {
	auth: {
		clientId: "43b94c7c-9681-41ce-a747-af8153163a0c",
		authority:
			"https://login.microsoftonline.com/18f15a3f-ea52-4261-b725-0b0f0d1bab03",
		redirectUri: `${window.location.origin}/auth/azure-callback`,
	},
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
	root.render(
		<React.StrictMode>
			<BrowserRouter>
				<MsalProvider instance={msalInstance}>
					<AuthProvider>
						<App />
						<ToastContainer
							pauseOnHover={false}
							pauseOnFocusLoss={false}
							autoClose={3000}
						/>
					</AuthProvider>
				</MsalProvider>
			</BrowserRouter>
		</React.StrictMode>
	);
});
